<template>
    <v-layout row wrap>
        <v-flex xs12 v-if="loading">
            <v-progress-linear :indeterminate="true"></v-progress-linear>
        </v-flex>
        <v-flex xs12 v-if="!loading">
            <v-layout>
                <v-flex xs12 sm4 v-for="column in columns" :key="column.ColumnNumber">
                    <v-layout row wrap v-for="category in column.Categories" :key="category.ID" class="category">
                        <v-flex xs12>
                            <span class="title">{{category.Name}}</span>
                        </v-flex>
                        <v-flex xs12 v-for="product in category.Products" :key="product.ID" class="subheading">
                            <OrderItemInput 
                                :ref="product.ID+'-orderItemInput'"
                                :orderID="orderID"
                                :product="product"
                                :editable="editable"
                                :initialQuantity="initialInputQuantity(product.ID)"
                                :initialStock="initialInputStock(product.ID)"
                                :initialComments="initialComments(product.ID)"
                                :showCommentField="showCommeneField"
                                :isOrganicsOrder="showStockEntry"
                                :isPrintPage=isPrintPage
                                @InputQuantityKeypress="InputQuantityKeypress"
                                @InputQuantityPaste="InputQuantityPaste"
                                >
                            </OrderItemInput>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>
        </v-flex>
    </v-layout>
</template>

<script>
import validationRules from "../../helpers/validationrules";
import ErrorAlert from "../common/ErrorAlert";
import auth from '@/services/auth';
import OrderItemInput from '@/components/orders/OrderItemInput.vue';

export default {
    components: {
        ErrorAlert,
        OrderItemInput
    },
    props: [
        'loading',
        'products',
        'userEmail',
        'store',
        'department',
        'date',
        'editable',
        'showCommeneField',
        'orderID',
        'showStockEntry',
        'isPrintPage'

    ],
    data() {
        return {
            rules: validationRules.rules,
            quantity: 0,
            productComment: null,
            commentProductID: null,
            commentOrderID: null
        };
    },
    computed: {
        refsArray() {
            let arr = [];
            for (let i = 0; i < this.products.length; i++) {
                const product = this.products[i];
                arr.push(product.ID+'-orderItemInput');
            }
            return arr;
        },
        totalColumns(){
            if(this.$vuetify.breakpoint.xs){
                return 1;
            }

            return 3;
        },
        productsColumnLength(){
            return Math.ceil(this.products.length / this.totalColumns);
        },
        categories(){
            let categories = {};
          
            this.products.forEach(p => {
                if(!categories[p.Category.ID]){
                    categories[p.Category.ID] = {
                        Products: [],
                        Name: p.Category.Name,
                        ID: p.Category.ID,
                        SortOrder: p.Category.SortOrder
                    };
                }

                categories[p.Category.ID].Products.push(p);
            });

            return categories;
        },
        columns(){
            let columns = [];

            // Starting column
            columns.push({
                ColumnNumber: 1,
                Categories: []
            });

            let categoryIDsInOrder = [];
            for(var property in this.categories){
                if(this.categories.hasOwnProperty(property)){
                    categoryIDsInOrder.push(property);
                }
            }
            categoryIDsInOrder = categoryIDsInOrder.sort((a, b) => {
                if(this.categories[a].SortOrder < this.categories[b].SortOrder){
                    return -1;
                } else if(this.categories[a].SortOrder > this.categories[b].SortOrder){
                    return 1;
                }

                return 0;
            });

            for(let j = 0; j < categoryIDsInOrder.length; j++){
                let categoryID = categoryIDsInOrder[j];

                let column = columns.length - 1;
                columns[column].Categories.push(this.categories[categoryID]);

                let row = 0;
                for(let i = 0; i < columns[column].Categories.length; i++){
                    row += columns[column].Categories[i].Products.length;
                }
                if(row >= this.productsColumnLength && column < this.totalColumns - 1){
                    // New column
                    columns.push({
                        ColumnNumber: column + 2,
                        Categories: []
                    });
                }
            }
            return columns;
        },
    },
    methods: {
        clearInput(){
            for (let i = 0; i < this.refsArray.length; i++) {
                var referenceString = this.refsArray[i]
                this.$refs[referenceString][0].clearInput();
            }
        },
        initialInputQuantity(productID) {
            let data = this.$store.state.placeOrderStore.orderProducts

            let total = 0;

            for(let i = 0; i < data.length; i++) {
                if(data[i].Product.ID == productID) {
                    total += data[i].Quantity;
                }
            }

            if(total == 0){
                return "";
            }

            return total;
        },
        initialInputStock(productID) {
            let data = this.$store.state.placeOrderStore.orderProducts

            let total = 0;

            for(let i = 0; i < data.length; i++) {
                if(data[i].Product.ID == productID) {
                    total += data[i].Stock;
                }
            }

            if(total == 0){
                return "";
            }

            return parseInt(total);
        },
        initialComments(productID) {
            let data = this.$store.state.placeOrderStore.ordersProductsComments;

            let comments = null;

            var orderProductsComment = data.find(x => x.ProductID == productID);
            if(orderProductsComment) {
                comments = orderProductsComment.Comments;
            }

            if(!comments) {
                return "";
            }

            return comments;
        },
        InputQuantityKeypress(evt) {
            var charCode = (evt.which) ? evt.which : event.keyCode
            if (charCode > 31 && (charCode < 48 || charCode > 57))
                    event.preventDefault();  
        },
        InputQuantityPaste(e) {
            var clipboardData = e.clipboardData || e.originalEvent.clipboardData || window.clipboardData;
            var pastedData = clipboardData.getData('text');
            if(!Number.isInteger(+pastedData)) {
                  event.preventDefault();  
            }
        },
    },
    created(){

    }
};
</script>

<style>
.category {
    page-break-inside: avoid;
    margin-bottom: 8px;
}
</style>
